var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-lg" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12 col-md-4 mt-3" }, [
        _c(
          "div",
          {
            staticClass: "card",
            staticStyle: { cursor: "pointer" },
            on: {
              click: function ($event) {
                return _vm.PushTo("/impressum")
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "card-body text-center" },
              [
                _c("font-awesome-icon", {
                  staticClass: "fa-5x",
                  staticStyle: { color: "#198fcf" },
                  attrs: { icon: ["fas", "fa-circle-info"] },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [_vm._v("Impressum")]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col-sm-12 col-md-4 mt-3",
          staticStyle: { cursor: "pointer" },
          on: {
            click: function ($event) {
              return _vm.PushTo("/datenschutz")
            },
          },
        },
        [
          _c("div", { staticClass: "card" }, [
            _c(
              "div",
              { staticClass: "card-body text-center" },
              [
                _c("font-awesome-icon", {
                  staticClass: "fa-5x",
                  staticStyle: { color: "#198fcf" },
                  attrs: { icon: ["fas", "fa-shield-halved"] },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _vm._v("\n\t\t\t\tDatenschutz\n\t\t\t"),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-12 col-md-4 mt-3" }, [
        _c(
          "div",
          {
            staticClass: "card",
            staticStyle: { cursor: "pointer" },
            on: {
              click: function ($event) {
                return _vm.PushTo("/disclaimer")
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "card-body text-center" },
              [
                _c("font-awesome-icon", {
                  staticClass: "fa-5x",
                  staticStyle: { color: "#198fcf" },
                  attrs: { icon: ["fas", "fa-file-lines"] },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _vm._v("\n\t\t  \t\t\tDisclaimer\n\t\t\t\t"),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-12 col-md-4 mt-3" }, [
        _c(
          "div",
          {
            staticClass: "card",
            staticStyle: { cursor: "pointer" },
            on: {
              click: function ($event) {
                return _vm.PushTo("/contact")
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "card-body text-center" },
              [
                _c("font-awesome-icon", {
                  staticClass: "fa-5x",
                  staticStyle: { color: "#198fcf" },
                  attrs: { icon: ["fas", "fa-phone"] },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _vm._v("\n\t\t  \t\t\tKontakt\n\t\t\t\t"),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-12 col-md-4 mt-3" }, [
        _c(
          "div",
          {
            staticClass: "card",
            staticStyle: { cursor: "pointer" },
            on: {
              click: function ($event) {
                return _vm.PushTo("/agb")
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "card-body text-center" },
              [
                _c("font-awesome-icon", {
                  staticClass: "fa-5x",
                  staticStyle: { color: "#198fcf" },
                  attrs: { icon: ["fas", "section"] },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _vm._v("\n\t\t  \t\t\tAGB\n\t\t\t\t"),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-12 col-md-4 mt-3" }, [
          _c(
            "div",
            {
              staticClass: "card",
              staticStyle: { cursor: "pointer" },
              on: {
                click: function ($event) {
                  return _vm.PushTo("/signedin")
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "card-body text-center" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "fa-5x",
                    staticStyle: { color: "#198fcf" },
                    attrs: { icon: ["fas", "up-from-bracket"] },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "text-center" }, [
                _vm._v("\n\t\t  \t\t\tZum Hauptmenü\n\t\t\t\t"),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }